import React from 'react';
import PropTypes from "prop-types";

import './cardFooter.less';

// Hardcoding border-box for the styling for this footer until we get around to changing how it is layed out
const CardFooter = (props) => (
        <div className="card-footer" style={{boxSizing: 'border-box'}}>
            <div className="left-content-footer">
                {props.leftContent}
            </div>
            <div className="right-content-footer">
                {props.rightContent}
            </div>
        </div>
    );

CardFooter.propTypes = {
    leftContent: PropTypes.element,
    rightContent: PropTypes.element
};

export default CardFooter;



// WEBPACK FOOTER //
// ./src/react/card/CardFooter.jsx